import * as yup from "yup";

export const transfer_schema = {
  to: "",
  amount: "",
  // reason: "",
  // is_same_day: true,
  // other_reason: "",
};

export const transfer_validation_schema = yup.object().shape({
  to: yup.object().required("to_account_required"),
  amount: yup
    .string()
    .required("amount_required")
    .matches(/^(?:\d+|\d+\.\d*)$/, "amount_digit_validation"),
  // reason: yup.object(),
  // is_same_day: yup.boolean(),
  // other_reason: yup.string(),
});
